import {
  BadgeEuro, ClipboardCheck, CloudHail, FileSearch, Gem, KeyRound, ShieldAlert,
} from "lucide-react";

export const SERVICE_ICONS = { BadgeEuro, ClipboardCheck, CloudHail, FileSearch, Gem, KeyRound, ShieldAlert };

export const ServiceIcon = ({ name, className }) => {
  const Icon = SERVICE_ICONS[name] || FileSearch;
  return <Icon className={className} strokeWidth={1.75} aria-hidden="true" />;
};
